<template>
  <div>
    <v-row style="height:200px" justify="center">
      <v-col class="col-9 col-sm-9 col-md-8 col-lg-8">
        <v-row align="center" style="height:100%">
          <div class="loginBtn centerBtn" style="width:100%; cursor: pointer; background:#215DA7" @click="downloadLink()">
            <h3 class="mx-2" style="color:#FFFFFF">點此下載考試連結 - WindowsLink</h3>
            <v-icon color="#FFF">mdi-download</v-icon>
          </div>
        </v-row> 
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'Link',
  data:()=>({
    viewStyle:{},
    images:{
      new_logo: require('@/assets/image/erp_logo.png'),
      windowsLink1: require('@/assets/image/windowsLink1.png'),
    },
  }),
  mounted(){},
  watch:{},
  methods:{
    downloadLink(){
      window.location.href='https://exam.cerps.org.tw/study-0.0.1-SNAPSHOT/file/common/download?name=demo/CERPS專業認證考試.vbs';
    },
  }
}
</script>
